<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">

        <div class="card-body px-lg-5 py-lg-5" :class="{loading: entrando}">
          <div class="text-center text-muted mb-4">
            <small>Entre com suas credenciais</small>
          </div>
          <base-alert :type="alerta.tipo" v-if="alerta.aberto" :class="{shake: alerta.shake}">
            <span class="alert-inner--icon mr-2">
              <i :class="alerta.icone"></i>
            </span>
            <span class="alert-inner--text">{{alerta.mensagem}}</span>
          </base-alert>

          <form role="form" @submit="fazerLogin()">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Email"
              addon-left-icon="ni ni-email-83"
              v-model="email.v"
              :error="email.msg"
              name="email"
              @keypress.enter="fazerLogin()"
            ></base-input>

            <base-input
              class="input-group-alternative"
              placeholder="Senha"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="senha.v"
              :error="senha.msg"
              @keypress.enter="fazerLogin()"
            ></base-input>

            <div class="text-center">
              <base-button type="primary" class="my-4" @click="fazerLogin()">Entrar</base-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <router-link to="/recovery" class="text-light">
              <small>Esqueceu sua senha?</small>
            </router-link>
        </div>
        <div class="col-6 text-right">
            <a href="https://conectflow.com.br/assinar" class="text-light">
              <small>Assine agora!</small>
            </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import usuario from "@/cflow/usuario.js";
import storage from "storage";
import router from '@/router'
export default {
  name: "login",
  data() {
    return {
      entrando: false,
      alerta: {
        aberto: false,
        shake: false,
        tipo: "",
        mensagem: "",
        icone: "",
      },
        email: { v: "", msg: "" },
        senha: { v: "", msg: "" },
        manter: false
    };
  },
  methods: {
    fazerLogin: function () {
      var app = this;
      app.alerta.shake = false;
      this.entrando = true
      usuario
        .login(this.email.v, this.senha.v)
        .then((usuario) => {
          // Se retornou o token então logou:
          if (usuario.token) {
            app.alerta = {
              aberto: true,
              tipo: "success",
              mensagem: 'Login bem sucedido!',
              icone: "fas fa-check-circle",
            };
            storage.set("user", usuario);

            let go = '/';
            if(usuario.tipo == 'pro') {
              go = '/agenda-protetica';
            }

            setTimeout(function(){
                router.push(go);
            },1000);
          }
        })
        .catch((error) => {
        
          if (error.response.status == 406) {
            app.email.msg = '';
            app.senha.msg = '';
            app.alerta = {
              aberto: true,
              tipo: "danger",
              mensagem: 'Não foi possível realizar seu login.',
              icone: "fas fa-exclamation-triangle",
              shake: true
            };
          }

        }).finally(() => {
          this.entrando = false
        })
    },
  },
};
</script>
<style>
.shake{
    animation: shake 0.35s 1 ease-in;
}
@keyframes shake{
  0%{
    transform: translate3d(0,0,0);
  }
  20%{
    transform: translate3d(-5%,0,0);
  }
  40%{
    transform: translate3d(5%,0,0);
  }
  60%{
    transform: translate3d(-5%,0,0);
  }
  80%{
    transform: translate3d(5%,0,0);
  }
  100%{
    transform: translate3d(0,0,0);
  }
}
</style>
